
import { Image } from "@heroui/react"
import WhatsAppLink from "../../../../../layout/components/WhatsAppLink";
import { FaRegEnvelope } from "react-icons/fa";
export default function InfoContacto() {

  return (
    <div className="flex w-full h-fit rounded-2xl bg-white shadow-xl py-20 items-center justify-center">
      <div className="flex flex-col">
        <div className="flex flex-col lg:flex-row">

          <Image
            src="./vegan/equipo/karla&pedro.webp"
            alt="founders"
            radius="full"
            className="w-sm lg:ml-5"
          />

          <div className="flex flex-col pl-10 w-full">
            <h5>Karla Trejo</h5>
            <div className="flex flex-row pl-10">
              <WhatsAppLink
                phoneNumber="+529991268546"
                displayNumber="(999) 126 8546"
              />
            </div>
            <h5>Pedro Rueda Flores</h5>
            <div className="flex flex-row pl-10">
              <WhatsAppLink
                phoneNumber="+529991370515"
                displayNumber="(999) 137 0515"
              />
            </div>
            <h5>Yumil Rueda Flores</h5>
            <div className="flex flex-row pl-10">
              <WhatsAppLink
                phoneNumber="+330661880915"
                displayNumber="(999) 190 0084"
              />
            </div>
          </div>
        </div>

        <div
          className="flex flex-row items-center justify-center gap-4 hover:cursor-pointer pt-10"
          onClick={() => window.location.href = "mailto:veganvegetarian@hotmail.com"}
        >
          <FaRegEnvelope />
          <a
            href="mailto:veganvegetarian@gmail.com"
            className="text-lg place-self-center text-primary hover:underline"
          >
            veganvegetarian@hotmail.com
          </a>

        </div>

      </div>
    </div>
  );
}
